/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAllocations = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 10a8 8 0 0 1 8-8h1v9H2zm2.083-1H9V4.083A6.005 6.005 0 0 0 4.083 9zM13 2h1a8 8 0 0 1 8 8v1h-9zm2 2.083V9h4.917A6.005 6.005 0 0 0 15 4.083zM2 13h9v9h-1a8 8 0 0 1-8-8zm2.083 2A6.005 6.005 0 0 0 9 19.917V15zM13 13h9v1a8 8 0 0 1-8 8h-1zm2 2v4.917A6.005 6.005 0 0 0 19.917 15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAllocations as Allocations };
